export default __webpack_public_path__ + "static/media/gem-icon-navbar.10dbbb52.svg";